export const environment = {
  baseURL: 'https://gestionmontepio.gruposca.net/APIGESTION-1/',
  env: 'test'
};
